export const blue = [
  "global-settings",
  "invite-team-member",
  "rich-text-ui",
  "client-menu",
  "clients-ui",
  "notes-ui",
];

export const infrastructure = [
  "app-loader-ui",
  "canopy-admin-ui",
  "canopy-styleguide",
  "canopy-urls",
  "client-portal",
  "common-dependencies",
  "common-deps",
  "cp-client-auth",
  "error-logging",
  "feature-toggles-ui",
  "feature-toggles",
  "fetcher",
  "frontend-node-server",
  "integrations-ui",
  "mobile-root-config",
  "pre-auth-ui",
  "primary-navbar",
  "prototypes-ui",
  "sofe-inspector",
  "testing-tools",
  "toast-service",
  "toolbox",
  "webview-ui",
  "login-ui",
];

export const gold = ["billing-ui", "transcripts-ui"];

export const green = [
  "docs-ui",
  "document-editor-ui",
  //it appears that letter-generator-ui and letters-ui are the same,
  //but sofe-inspector registers letters-ui
  "letter-generator-ui",
  "letters-ui",
  "signing-ui",
];

export const red = [
  "app-dashboard-ui",
  "notices-ui",
  "reporting-ui",
  "tasks-ui",
  "end-user-forms-ui",
  "engagements-ui",
  "logic-ui",
  "resolution-cases-menu",
  "resolution-cases-ui",
  "sme-navbar",
  "sme-root-config",
  "sme-ui",
  "sme-version",
];

export const wraith = [
  "calendar-ui",
  "communications-ui",
  "forms-ui",
  "notifications-ui",
];

export const corona = [];

export const shadow = ["payments-ui"];

export const sapphire = ["workflow-builder-ui"];
